import { GridColDef } from '@mui/x-data-grid-pro';

export const educatorColumns: GridColDef[] = [
  {
    field: 'name',
    headerName: 'Navn',
    flex: 1,
  },
  {
    field: 'companyName',
    headerName: 'Virksomhed',
    flex: 1,
  },
  {
    field: 'email',
    headerName: 'E-mail',
    flex: 1,
  },
  {
    field: 'phone',
    headerName: 'Telefonnummer',
    flex: 1,
  },
];
